if (!customElements.get("td-gallery-modal")) {
  class TdGalleryModal extends HTMLElement {
    constructor() {
      super();
      this.modal = this; 
    }

    connectedCallback() {
      const galleryWrapper = document.querySelector(".td-product__gallery__wrapper");
      if (galleryWrapper) {
        galleryWrapper.addEventListener("click", (event) => {
          const trigger = event.target.closest("[data-modal-trigger-id]");
          if (trigger) {
            this.openModal(trigger);
          }
        });
      }

      this.addEventListener("click", (event) => {
        const closeBtn = event.target.closest("[data-modal-close]");
        if (closeBtn || event.target === this.modal) {
          this.closeModal();
        }
      });
    }
    
    

    openModal(trigger) {
      const triggerId = trigger.dataset.modalTriggerId;

      if (!triggerId) return;

      this.modal.setAttribute("active", "");
      document.body.setAttribute("td-gallery-modal-open", "");

      document.dispatchEvent(
        new CustomEvent("modal-opened", {
          detail: { mediaId: triggerId },
        })
      );
    }

    closeModal() {
      this.modal.removeAttribute("active");
      document.body.removeAttribute("td-gallery-modal-open");
      document.dispatchEvent(
        new CustomEvent("modal-closed", {
          detail: {},
        })
      );
    }
  }

  customElements.define("td-gallery-modal", TdGalleryModal);
}
